import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { Link, useLocation } from 'react-router-dom';
import $ from 'jquery';
import { EndPoints } from '../../constants/api-config';
// Signup
// ==========================================
// Signup: Common
import Help from './_common/help';
import {Navbar} from './_common/navbar';
import {SkipRegister} from './_common/skipRegister';
import photoWoman from './../../assets/images/placeholder/photo-woman.jpeg';
import { resetUser } from './../../actions/user-api';
import { resetAuth } from './../../actions/auth-api';

// Signup: Views
import { Step1 } from './step1';
import { Step2 } from './step2';
import {Step3} from './step3/index';
// import Step3 from './step3/_oldindex';
import {Step4} from './step4';
import {Step5} from './step5';
import {Step6} from './step6';

import { Cookies } from '../_common/cookies';
import * as R from 'ramda';
import { fetchUserById, getUserAddress, getUserRepresentatives, getUserRepresentativeAddress, getUserServices, fetchPartnerCustomization } from '../../actions/user-api';
import JwtDecode from 'jwt-decode';

export const Signup = () => {
  const location = useLocation();  
  const router = useSelector(state => state.router);
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const auth = useSelector(state => state.auth);
  const [passwordRequirements, setPasswordRequirements] = useState({ hasLower: false, hasUpper: false, hasDigits: false });
  const [personalDataRequirements, setPersonalDataRequirements] = useState({
    civil: false,
    familiar: false,
    children: false,
    contact: false,
    profession: false
  });
  const [monReferentRequirements, setMonReferentRequirements] = useState({principal: false, other: false});
  const [monServiceRequirements, setMonServiceRequirements] = useState({ communes: true, personnal: false });
  const hideModal = () => {
    $('.modal').modal("hide");
  }

  let SERVER_ADDR_V1 = EndPoints.backendHost;

  let pathname = router.location.pathname.toLowerCase();
  let stepNum = pathname.substring(17,18);
  let step = stepNum !== '' ? parseInt(stepNum): 1;

  const [loadingFinished, setLoadingFinished] = useState(false);

  const [stepsCompleted, setStepsCompleted] = useState([]);
  const [partnerCustomization, setPartnerCustomization] = useState({
    logoBase64Encoded: undefined,
    color: undefined
  });

  const partnerId = new URLSearchParams(location.search).get("partnerId");
  const color = new URLSearchParams(location.search).get("color");

  useEffect(() => {

    if (R.isNil(user.user) && !R.isNil(partnerId) && partnerId !== ""){
      setPartnerCustomization({...partnerCustomization,
        color: color,
        logoBase64Encoded: `${SERVER_ADDR_V1}/partners/${partnerId}/logo`
      });
    }
  }, [partnerId, color]);

  useEffect(() => {
    var accessToken = localStorage.getItem("access_token");
    if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
      var decoded = JwtDecode(accessToken);
      if (!R.isNil(decoded) && !R.isNil(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"])) {
        dispatch(fetchUserById(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]));
      }
    }else{
      setLoadingFinished(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    var accessToken = localStorage.getItem("access_token");
    if (accessToken !== undefined && accessToken !== null && accessToken !== '') {
      var decoded = JwtDecode(accessToken);
      if (!R.isNil(decoded) && !R.isNil(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"])) {
        dispatch(fetchUserById(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth.registered]);


  useEffect(() => {
    let tmpUser = user.user;
    if (!R.isNil(tmpUser) && tmpUser.id !== undefined) {
      dispatch(getUserAddress(tmpUser.id));
      dispatch(getUserRepresentatives(tmpUser.id));
      dispatch(getUserServices(tmpUser));
      if(!R.isNil(tmpUser.partnerId) && tmpUser.partnerId !== '00000000-0000-0000-0000-000000000000'){
        fetchPartnerCustomization(tmpUser.partnerId)
        .then((customization) => {
          if(!R.isNil(customization)){
            setPartnerCustomization(customization);
            setLoadingFinished(true);
          }
        }).catch(() => setLoadingFinished(true))
      }else{
        setLoadingFinished(true);
      }
      
      checkSteps();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.user]);

  useEffect(() => {
    if(!R.isNil(user.referents) && user.referents.length > 0){
      user.referents.forEach(r => {
        dispatch(getUserRepresentativeAddress(r))
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.referents]);

  useEffect(() => {
    checkSteps();
  }, [!R.isNil(user.user) ? user.user.onBoardingStep : user.user]);


  function checkSteps(){
    let tmpSteps = [];
    let tmpUser = user.user;
    let step = !R.isNil(user) && !R.isNil(tmpUser) &&  !R.isNil(tmpUser.onBoardingStep) ? parseInt(JSON.stringify(tmpUser.onBoardingStep).replace(/\D/g, "")) : -1;
    if (step !== 6 && step !== -1) {
			if(tmpUser.onBoardingStep === "Completed"){
        step = 6;
			}
		}

    if (step !== -1){
      tmpSteps = Array.from({length: step}, (_, i) => i + 1);
    }
    setStepsCompleted(tmpSteps);
  }

  useEffect(() => {
    if (!R.isNil(user.user)){
      checkSteps();
    }
    if (step === 1 && !stepsCompleted.includes(1) && (auth.loggedIn !== true || user.user === undefined)) {
      $('#commencerRegister').modal('show');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingFinished]);

  if(loadingFinished === false)
    return '';

  return (
    <div className={"layout layout-row" + (!R.isNil(partnerCustomization) && !R.isNil(partnerCustomization.color) ? "" : " bg-gradient-primary")} style={{backgroundColor: "#" + partnerCustomization.color }}>
      <h1 className="sr-only visually-hidden">Assist@</h1>
      <ToastContainer />
      <Navbar stepsCompleted={stepsCompleted} passwordRequirements={passwordRequirements} step={step} 
        personalDataRequirements={personalDataRequirements} monReferentRequirements={monReferentRequirements}
        monServiceRequirements={monServiceRequirements} logoContent={partnerCustomization.logoBase64Encoded}/>
      <main role="main" className="view flex-grow-1 bg-gradient-light">
        <h1 className="sr-only visually-hidden">Assist@: Main</h1>
        <Help />
        {
          step === 1 ? <Step1 passwordRequirements={passwordRequirements} setPasswordRequirements={(req)=> {setPasswordRequirements(req)}}/>: 
          step === 2 ? <Step2 personalDataRequirements={personalDataRequirements} setPersonalDataRequirements={(req)=>setPersonalDataRequirements(req)}/>:
          step === 3 ? <Step3 monReferentRequirements={monReferentRequirements} setMonReferentRequirements={(req) => setMonReferentRequirements(req)} />:
          step === 4 ? <Step4 monServiceRequirements={monServiceRequirements} setMonServiceRequirements={(req) => {setMonServiceRequirements(req)}}/>:
          step === 5 ? <Step5 />:
          step === 6 ? <Step6/>:
          ''
        }
      </main>
      {
        (!R.isNil(user.user) && !R.isNil(user.user.partnerId)) || window.location.search !== '' ? 
          ''
        :
        <div className="modal fade px-0" id="commencerRegister" aria-labelledby="commencerRegisterLabel" aria-hidden="true">
          <div className="modal-dialog container-modal px-2">
            <div className="modal-content">
              <div className="modal-body">
                <div className="grid grid-md-2 grid-lg-copy gx-3 gx-lg-4">
                  <div className="block">
                    <div className="img-placeholder img-copy rounded bg-light" style={{ backgroundImage: `url(${photoWoman})`, backgroundSize: 'Cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'left top' }} alt="placeholder" />
                  </div>
                  <div className="block d-flex flex-column justify-content-between">
                    <h1 className="h1 text-primary font-weight-bolder ls-n1 lh-copy mb-0 mt-4 mt-lg-auto" id="commencerRegisterLabel">Bienvenue sur Assist@.</h1>
                    <p className="lh-base font-weight-normal my-3">Après une expérience dans les services, et notamment la gestion de patrimoine durant 15 ans, j’ai décidé de créer l’entreprise ASSIST@ afin de faciliter l’administratif pour vous mais surtout pour vos proches.</p>

                    <div className="w-100"><hr className="my-3" /></div>
                    <p className="h6 text-primary font-weight-demi lh-1 mt-2">Pour vous :</p>
                    <p className="h6 o-60 font-weight-normal lh-base">Avec ANTICIPA, vous avez enfin un espace dédié regroupant tous les organismes en lien avec vous (noms et adresses) qui permet de préparer vos démarches.
  Votre synthèse innovante disponible à la fin de votre dossier est simple et modifiable. Elle vous permet en un « coup d’œil » de voir l’intégralité de vos services : centre de CPAM, fournisseur d’électricité, d’eau, abonnements, nom de votre notaire… le tout à jour. De plus, vous avez la possibilité de noter le tarif de vos abonnements et prélèvements qui
  vous permet d’avoir un suivi de votre situation.</p>
                    <p className="h6 text-primary font-weight-demi lh-base">Pour vos proches :</p>
                    <p className="h6 o-60 font-weight-normal lh-base mb-2">Un service qui s’articule autour de la gestion administrative, accessible en ligne, permettant
  l’automatisation des courriers obligatoires de la création à l&#39;envoi inclus le moment venu.<br/>
  Notre offre apporte gain de temps, facilité de traitement, fiabilité et anticipation.<br/>
  Notre mode de fonctionnement est basé sur la confidentialité et le professionnalisme.</p>
                    <div className="w-100"><hr className="my-3" /></div>
                    
                    <p className="h6 lh-base font-weight-normal my-3">
                      Faites pour vos proches les démarches qu’ils auraient eu à faire pour vous<br/>
                      Notre équipe est à votre écoute, bon dossier.
                    </p>
                    <p className="h5 lh-base font-weight-normal ml-auto text-right mb-4">
                      <i>Aurélie Fournier</i><br/>
                      <span className="fs-3 text-muted lh-1">Fondatrice</span>
                    </p>
                    <div className="block mt-4 mt-lg-auto text-right">
                      <Link to="/index" className="btn btn-light mr-1 mr-lg-3" onClick={() => {
                        dispatch(resetAuth());
                        dispatch(resetUser());
                        if (localStorage.getItem("access_token") !== undefined) {
                          localStorage.removeItem("access_token");
                        }
                        hideModal();
                      }}>Quitter</Link>
                      <Link to="/auth/signup/step1" className="btn btn-info" data-dismiss="modal">Commencer</Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      
      <SkipRegister />
      <Cookies />
    </div>
  )
}
